import { render, staticRenderFns } from "./AllotRoles.vue?vue&type=template&id=72b21485&scoped=true&"
import script from "./AllotRoles.vue?vue&type=script&lang=js&"
export * from "./AllotRoles.vue?vue&type=script&lang=js&"
import style0 from "./AllotRoles.vue?vue&type=style&index=0&id=72b21485&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b21485",
  null
  
)

export default component.exports